import React from 'react';
import NavItem from 'react-bootstrap/NavItem';
import NavLink from 'react-bootstrap/NavLink';
import Dropdown from 'react-bootstrap/Dropdown';
import { faSearch, faSignOutAlt, faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { logout } from "../../../api/auth";
import NoAvatar from "../../../assets/images/no-avatar.png";


export default function MenuTop(props) {
    const { user } = props;

    const logoutUser = () => {
        logout();
        window.location.reload();
    }

    return (
        <>
            <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
                <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                    <FontAwesomeIcon className="fa fa-bars" icon={faBars} />
                </button>
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item dropdown no-arrow d-sm-none">
                        <div className="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in" aria-labelledby="searchDropdown">
                            <form className="form-inline mr-auto w-100 navbar-search">
                                <div className="input-group">
                                    <input type="text" className="form-control bg-light border-0 small" placeholder="Search for..." aria-label="Search" aria-describedby="basic-addon2" />
                                    <div className="input-group-append">
                                        <button className="btn btn-primary" type="button">
                                            <FontAwesomeIcon className="fas fa-search fa-sm" icon={faSearch} />
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </li>
                    <div className="topbar-divider d-none d-sm-block"></div>
                    <Dropdown as={NavItem} className="nav-item dropdown no-arrow" >
                        <Dropdown.Toggle as={NavLink} className="nav-link dropdown-toggle">
                            <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                                {`${user.nombres} ${user.apellido_paterno} ${user.apellido_materno}`}
                            </span>
                            <img className="img-profile rounded-circle" src={NoAvatar} alt="profile" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Divider className="dropdown-divider" />
                            <Dropdown.Item onClick={logoutUser}>
                                <FontAwesomeIcon className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" icon={faSignOutAlt} />
                                Logout
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                </ul>
            </nav>
        </>
    )
}